import React, { useEffect } from 'react';
import WHStep2Conatiner from './wh-step-2/WHStep2.conatiner';
import WHStep1Container from './wh-step-1/WHStep1.conatiner';
import * as Styles from './WH.style';
import WHStep3Container from './wh-step-3/WHStep3.container';
import WHStep4Container from './wh-step-4/WHStep4.container';
import WHStep5Container from './wh-step-5/WHStep5.container';
import WHLastStepConatiner from './wh-last-step/WHLastStep.container';
import { get } from 'lodash';
import { useQuery } from 'react-query';

const WH = ({
  isLoading,
  formikProp,
  whAppData,
  domainLookUploading,
  whSizesData,
  whSizesPricesData,
  domainLookUp,
}) => {
  const { setFieldValue } = formikProp;
  const { data: whRegionData } = useQuery('/wh/regions', {
    onSuccess: (data) => {
      const defaultRegion = data?.data.find((region) => region?.default);
      setFieldValue('region', defaultRegion?.id || '');
    },
  });

  useEffect(async () => {
    const mostPopularSizeData = await get(whSizesData, 'data', []).find((size) => size?.default);
    const price = await get(whSizesPricesData, 'prices_wh_sizes', []).find((val) => mostPopularSizeData?.id == val?.id);
    setFieldValue('size', mostPopularSizeData);
    setFieldValue('prices.yearly.size', +price?.price_yearly_usd);
    setFieldValue('prices.size', +price?.price_monthly_usd);
  }, [whSizesPricesData, whSizesData]);

  return (
    <Styles.WHSC>
      <WHStep1Container formikProp={formikProp} domainLookUp={domainLookUp} domainLookUploading={domainLookUploading} />
      <WHStep2Conatiner formikProp={formikProp} whSizesData={whSizesData} whSizesPricesData={whSizesPricesData} />
      <WHStep3Container formikProp={formikProp} whAppData={whAppData} />
      <WHStep4Container formikProp={formikProp} whRegionData={whRegionData} />
      <WHStep5Container formikProp={formikProp} />
      <WHLastStepConatiner isLoading={isLoading} formikProp={formikProp} />
    </Styles.WHSC>
  );
};
export default WH;
